import dataTypeConstants from "../../common/data-type.constants";
export class Pagination {
	pageindex?: number;
	pagecount?: number;
	pagesize?: number;
	total?: number;
	visible?: boolean;
	
	/**
	 *
	 */
	constructor(options?: {
		pageindex?: number;
		pagesize?: number;
		pagecount?: number;
		total?: number;
		visible?: boolean;
	}) {
		options = options || {
			pagecount: 1 ,
			pageindex: 0 ,
			pagesize: 0 ,
			total: 0 ,
			visible: true
		};
		this.pagecount = options.pagecount;
		this.pageindex = options.pageindex;
		this.pagesize = options.pagesize;
		this.total = options.total;
		this.visible = options.visible || true;
	}
}

export interface IColumnOptions {
	index?: number;
	name?: string;
	style?: CSSStyleDeclaration;
	isHidden?: boolean;
	isShow?: boolean;
	sortType?: string;
	fixed?: string;
	canSort?: boolean;
	clientMapPrefix?: string;
	localizationKey?: string;
	dataType?: string;
	displayType?: string;
	displayTypeFormat?: string;
	SortDirection?: number;
	fieldName?: string;
	canEdit?: boolean;
    defaultSort?: boolean;
    isFixed?: boolean;
    LookupInfo?: {
        LookupType: string;
        SearchType: number;
    };
    SearchName?: string;
    DisabledSearch?: Boolean;
}

export class ColumnOptions implements IColumnOptions {
	index: number;
	name: string;
	style?: CSSStyleDeclaration;
	isHidden: boolean;
	isShow?: boolean;
	sortType: string | "asc" | "desc";
	fixed: string;
	canSort: boolean;
	defaultSort: boolean;
	clientMapPrefix?: string;
	localizationKey?: string;
	dataType?: string;
	displayType?: string;
	displayTypeFormat?: string;
	SortDirection?: number;
	fieldName?: string;
    canEdit?: boolean;
    isFixed?: boolean;
    LookupInfo?: {
        LookupType: string;
        SearchType: number;
    };
    SearchName?: string;
    DisabledSearch?: Boolean;
	
	constructor(key: string , options?: IColumnOptions , style?: any) {
		this.name = key;
		this.index = options.index || 0;
		this.isShow = options.isShow || false;
		this.sortType = options.sortType || "asc";
		this.fixed = options.fixed;
		this.style = Object.assign({width: (options.displayType === dataTypeConstants.icon ? "60" : "150")}, style || {});
		this.canSort = options.canSort;
		this.defaultSort = options.defaultSort || false;
		this.clientMapPrefix = options.clientMapPrefix;
		this.localizationKey = options.localizationKey;
		this.dataType = options.dataType;
		this.displayType = options.displayType;
		this.displayTypeFormat = options.displayTypeFormat;
		this.SortDirection = options.SortDirection || 0;
		this.canEdit = options.canEdit;
        this.isFixed = options.isFixed;
        this.LookupInfo = options.LookupInfo;
        this.SearchName = options.SearchName;
        this.DisabledSearch = options.DisabledSearch;
		this.setFieldName(options);
	}
	
	private setFieldName(options?: IColumnOptions, locale?: string) {
		if (options.clientMapPrefix) {
			let langCode = localStorage.getItem('lang');
			if (locale) {
				langCode = locale;
			}
			this.fieldName = options.clientMapPrefix + langCode.substr(0,2).toUpperCase();
		} else {
			this.fieldName = options.name;
		}
	}
	
	get visible(): boolean {
		return this.index >= 0 && !this.isHidden;
	}
}

export class GridOptions<TSource = any , TSearchParam = any> {
	sources: TSource[];
	pagination: Pagination | null;
	columns: ColumnOptions[];
	criterias: TSearchParam | null;
	
	/**
	 *
	 */
	constructor(options: {
		columns: ColumnOptions[];
		searchParams?: TSearchParam;
		source?: TSource[];
		pagination?: Pagination;
	}) {
		this.columns = options.columns;
		this.criterias = options.searchParams || ({} as TSearchParam);
		this.sources = options.source || ([] as TSource[]);
		this.pagination = options.pagination;
	}
}

export class PayloadColumn {
	Index?: number;
	Name?: string;
	Style?: CSSStyleDeclaration;
	IsHidden?: boolean;
	IsShow?: boolean;
	SortType?: string | "asc" | "desc";
	Fixed?: string;
	CanSort?: boolean;
	ClientMapPrefix?: string;
	LocalizationKey?: string;
	DataType?: string;
	DisplayType?: string;
	DisplayTypeFormat?: string;
	SortDirection?: number;
	SearchName?: string;
	
	constructor(props?: IColumnOptions) {
		this.Index = props.index || null;
		this.Name = props.name || null;
		this.Style = props.style || null;
		this.IsHidden = props.isHidden || false;
		this.IsShow = props.isShow || false;
		this.SortType = props.sortType || "desc";
		this.Fixed = props.fixed || null;
		this.CanSort = props.canSort || null;
		this.ClientMapPrefix = props.clientMapPrefix || null;
		this.LocalizationKey = props.localizationKey || null;
		this.DataType = props.dataType || null;
		this.DisplayType = props.displayType || null;
		this.DisplayTypeFormat = props.displayTypeFormat || null;
		this.SortDirection = props.SortDirection || 0;
		this.SearchName = props.SearchName || null;
	}
}
